"use client";

import { useParams } from "next/navigation";
import { FaDownload } from "react-icons/fa6";
import Link from "next/link";
import { FaHome } from "react-icons/fa";

import TitleNewsBlock from "@/components/blocks/TitleNewsBlock/TitleNewsBlock";
import SocialShare from "@/components/shared/SocialShare";
import Spacer from "@/components/shared/Spacer";
import { getImageUrl } from "@/utils/getImageUrl";
import { EpaperMediaType } from "@/types/epaper";
import { handleEpaperClipDownload } from "@/utils/epaper";

interface EpaperSharePageViewProps {
  data: EpaperMediaType;
}

export default function EpaperSharePageView({ data }: EpaperSharePageViewProps) {
  const { id } = useParams();

  // const { data, error, isFetching } = useQuery({
  //   queryKey: ["fetchSingleEpaperMedia", id.toString()],
  //   queryFn: () => fetchSingleEpaperMedia({ id: id?.toString() }),
  //   refetchOnWindowFocus: false,
  // });

  return (
    <div>
      <div className="h-10 bg-white dark:bg-[#6d6d6d] dark:text-white shadow-md">
        <div className="container flex items-center justify-between h-full gap-2">
          <Link href={"/epaper"} aria-label="Go to epaper page">
            <FaHome className="text-xl " />
          </Link>

          <div className="flex items-center justify-center h-full gap-4">
            <button
              className="size-[30px] lg:size-[26px] rounded-full overflow-hidden bg-black text-white dark:text-black dark:bg-white  flex justify-center items-center"
              aria-label="Download"
              onClick={() =>
                handleEpaperClipDownload(data?.sizes?.hd?.filename || data?.path || "")
              }
            >
              <FaDownload />
            </button>
            <SocialShare title={"Deshabhimani epaper cut"} url={`/epaper/share/${id}`} />
          </div>
        </div>
      </div>

      <div className="container mt-8">
        {/* {isFetching ? (
          <div>Loading...</div>
        ) : error || !data ? (
          <div>Not Found!</div>
        ) : (
          <div className="bg-[#f0f0f0] dark:bg-[#212121]">
            <img
              src={getImageUrl(data?.filename || "")}
              alt={data?.alt ?? "Deshabhimani - ദേശാഭിമാനി ദിനപ്പത്രം"}
              className="w-auto h-auto max-h-[700px] mx-auto"
              loading="lazy"
            />
          </div>
        )} */}

        <div className="bg-[#f0f0f0] dark:bg-[#212121]">
          <img
            // hd (1920px) is omitted by the backend for clips narrower than that, so fall back to the original
            src={getImageUrl(data?.sizes?.hd?.filename || data?.path || "")}
            alt={data?.alt ?? "Deshabhimani - ദേശാഭിമാനി ദിനപ്പത്രം"}
            className="w-auto h-auto max-h-[700px] mx-auto"
            loading="lazy"
          />
        </div>

        <Spacer size="lg" />

        <TitleNewsBlock
          block={{
            id: "",
            blockType: "titleNewsBlock",
            title: "Latest News",
            orderBy: "latest",
            limit: 4,
            backgroundColor: "#ffffff",
          }}
          pageSlug="default"
        />

        <Spacer size="lg" />
      </div>
    </div>
  );
}
